import { DataCheckboxesOptions } from "../../types/Data";

export function getObjectFromOptions(
  optionsContainerId: string
): DataCheckboxesOptions {
  return [
    ...document.getElementById(optionsContainerId)!.querySelectorAll("label"),
  ].reduce((acc, option) => {
    return {
      ...acc,
      [(option.children[0] as HTMLInputElement).value]: {
        label: option.children[1].textContent as string,
        element: option as HTMLElement,
      },
    };
  }, {} as DataCheckboxesOptions);
}
